module.exports = __webpack_public_path__ + "img/荣誉顶部图.7728f4fe.png";